import ProductsDetailScreen from './ProductDetailScreen'

export default ProductsDetailScreen
